// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"4lkcN":[function(require,module,exports) {
(function() {
    window.sessionStorage.setItem("shoppableRecipeConfig", JSON.stringify({
        identifiers: {
            ingredientsContainerClassName: "c-recipe-content-ingredients",
            ingredientItemClassName: "c-recipe-content-ingredients__list-item"
        },
        colors: {
            primary: "#0C456E",
            secondary: "#ffffff"
        },
        cta: {
            borderRadius: "4px",
            fontSize: "1.125rem",
            padding: "0.5rem 1.875rem",
            margin: "0",
            height: "auto",
            shareIcon: {
                contents: "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",
                base64Encoded: true
            },
            alignment: "left"
        },
        labels: {
            shareTitle: "Agregar a la lista de compras o compartir",
            intro: "Compartiendo la lista de ingredientes para",
            closingRemarks: "Vea las instrucciones de cocci\xf3n completas en"
        }
    }));
    var scriptURL = "https://shoppablerecipe-widget-prod.unileversolutions.com/build/shoppable_recipe_widget_v1.js";
    var scriptElement = document.createElement("script");
    scriptElement.setAttribute("defer", "defer");
    scriptElement.setAttribute("src", scriptURL);
    document.body.appendChild(scriptElement);
})();

},{}]},["4lkcN"], "4lkcN", "parcelRequire9928")

//# sourceMappingURL=index.js.map
